const cookieButtons = document.querySelectorAll('.js--cookie-button');

const setCookieWithPreferences = () => {
    const cookieArray = [];
    let getCheckedCookieInput = document.querySelectorAll(
        '.cookie-bar__options input[type=checkbox]:checked',
    );
    for (let i = 0; i < getCheckedCookieInput.length; i++) {
        cookieArray.push(getCheckedCookieInput[i].dataset.gtmCookieTypes);
    }

    pushCookieTypesToDataLayer(cookieArray.join(','));
};

if (cookieButtons) {
    [].forEach.call(cookieButtons, (cookieButton) => {
        cookieButton.addEventListener('click', () => {
            if (cookieButton.classList.contains('js--cookies-with-preferences')) {
                setCookieWithPreferences();
            } else {
                pushCookieTypesToDataLayer(cookieButton.dataset.gtmCookieTypes);
            }
        });
    });
}

function pushCookieTypesToDataLayer(types) {
    window.dataLayer.push({
        event: 'enableCookie',
        cookieTypes: types,
    });

    types.split(',').forEach((type) => {
        window.dataLayer.push({
            event: 'enableCookie',
            cookieType: type,
        });
    });
}
